var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSosAlertTimeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4834_61394)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF2124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.584 19.3333V16H12.4173V19.3333H11.584ZM17.8965 16.8767L15.5311 14.5321L16.1257 13.9375L18.4702 16.3029L17.8965 16.8767ZM6.10482 16.8767L5.53107 16.3029L7.87565 13.9375L8.47023 14.5321L6.10482 16.8767ZM6.16732 6.83333V7.79479C6.16732 7.94438 6.21537 8.06729 6.31148 8.16354C6.40773 8.25965 6.53065 8.30771 6.68023 8.30771H17.3211C17.4707 8.30771 17.5936 8.25965 17.6898 8.16354C17.7859 8.06729 17.834 7.94438 17.834 7.79479V6.83333H6.16732ZM8.26982 9.14104L8.68023 10.2787C8.72287 10.3857 8.78697 10.4685 8.87253 10.5273C8.95794 10.586 9.05405 10.6154 9.16086 10.6154H14.8404C14.9472 10.6154 15.0434 10.586 15.1288 10.5273C15.2143 10.4685 15.2784 10.3857 15.3211 10.2787L15.7315 9.14104H8.26982ZM9.16086 11.4487C8.87461 11.4487 8.61503 11.3678 8.38211 11.2058C8.14919 11.044 7.98253 10.8269 7.88211 10.5546L7.38523 9.14104H6.68023C6.30732 9.14104 5.98968 9.00986 5.72732 8.7475C5.4651 8.48528 5.33398 8.16771 5.33398 7.79479V6H18.6673V7.79479C18.6673 8.16771 18.5362 8.48528 18.274 8.7475C18.0116 9.00986 17.694 9.14104 17.3211 9.14104H16.6161L16.0584 10.5737C15.9547 10.829 15.7907 11.0387 15.5663 11.2027C15.342 11.3667 15.0883 11.4487 14.8052 11.4487H9.16086Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4834_61394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosAlertTimeline);
export default __webpack_public_path__ + "static/media/sos-alert-timeline.569f420d84d11792eb707282dad8beb1.svg";
export { ForwardRef as ReactComponent };